import { render, staticRenderFns } from "./SurveysPrivateV2.vue?vue&type=template&id=2088f5d8&scoped=true"
import script from "./SurveysPrivateV2.vue?vue&type=script&lang=js"
export * from "./SurveysPrivateV2.vue?vue&type=script&lang=js"
import style0 from "./SurveysPrivateV2.vue?vue&type=style&index=0&id=2088f5d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2088f5d8",
  null
  
)

export default component.exports